import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  const [showVideoPopup, setShowVideoPopup] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);

  const closeVideoPopup = () => {
    setShowVideoPopup(false);
  };

  const closeVideoPopupForToday = () => {
    setShowVideoPopup(false);
    // 오늘 하루 다시 열지 않기 설정
    const today = new Date().toDateString();
    localStorage.setItem('videoPopupClosed', today);
  };

  // 컴포넌트 마운트 시 오늘 이미  닫았는지 확인
  useEffect(() => {
    const closedDate = localStorage.getItem('videoPopupClosed');
    const today = new Date().toDateString();
    
    if (closedDate === today) {
      setShowVideoPopup(false);
      return;
    }

    // 페이지 로드 후 1초 뒤에 팝업 표시
    const timer = setTimeout(() => {
      setShowVideoPopup(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Video Popup */}
      {showVideoPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50">
          <div className="relative bg-white rounded-lg overflow-hidden max-w-4xl w-full mx-4">
            {/* Close Button */}
            <button
              onClick={closeVideoPopup}
              className="absolute top-4 right-4 z-10 bg-black bg-opacity-50 text-white rounded-full w-10 h-10 flex items-center justify-center hover:bg-opacity-75 transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
            
            {/* Video Content */}
            <div className="p-6">
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                올딩스 로지스 회사소개
              </h3>
              <div className="relative aspect-video bg-gray-100 rounded-lg overflow-hidden">
                <iframe
                  src="https://drive.google.com/file/d/14m0JK7-Xw1YXteT27vHLFAjpcHmAuiQv/preview"
                  width="100%"
                  height="100%"
                  allow="autoplay; fullscreen"
                  allowFullScreen
                  className="rounded-lg"
                  title="올딩스 로지스 회사소개 동영상"
                ></iframe>
              </div>
              
              {/* Action Buttons */}
              <div className="flex justify-center gap-4 mt-6">
                <button
                  onClick={closeVideoPopup}
                  className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
                >
                  동영상 닫기
                </button>
                <button
                  onClick={closeVideoPopupForToday}
                  className="border-2 border-gray-400 text-gray-600 hover:bg-gray-400 hover:text-white px-6 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-time-line"></i>
                  오늘 하루 다시 열지 않기
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Company Video Modal */}
      {showVideoModal && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden">
            <div className="flex justify-between items-center p-4 border-b">
              <h3 className="text-xl font-bold text-gray-900">올딩스 로지스 회사소개</h3>
              <button
                onClick={() => setShowVideoModal(false)}
                className="text-gray-400 hover:text-gray-600 cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
            <div className="p-4">
              <div className="aspect-video w-full">
                <iframe
                  src="https://drive.google.com/file/d/14m0JK7-Xw1YXteT27vHLFAjpcHmAuiQv/preview"
                  width="100%"
                  height="100%"
                  allow="autoplay; fullscreen"
                  allowFullScreen
                  className="rounded-lg"
                  title="올딩스 로지스 회사소개 동영상"
                ></iframe>
              </div>
              <div className="text-center mt-4">
                <button
                  onClick={() => setShowVideoModal(false)}
                  className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-7 transition-colors whitespace-nowrap cursor-pointer"
                >
                  동영상 닫기
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section 
        className="relative h-[70vh] flex items-center justify-center bg-cover bg-center overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url('https://static.readdy.ai/image/4015a3fe38dcf49d1dfca5fec74a66c9/ffbac6013878baafc765b36c8616a60b.jpeg')`
        }}
      >
        {/* Content */}
        <div className="relative z-10 text-center px-4 max-w-6xl mx-auto pt-20">
          <div className="space-y-4">
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight drop-shadow-lg">
              고객과 성장하며 함께  웃는 3PL 전문회사
            </h1>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-yellow-300 leading-tight animate-fade-in-up animation-delay-500 drop-shadow-lg animate-bounce-horizontal">
              물류비 최저 단가 도전 !!!
            </h2>
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white leading-tight drop-shadow-lg">
              세심한 물류, 글로벌로 가는 힘
            </h3>
          </div>

          {/* CTA Buttons */}
          <div className="mt-16 flex justify-center">
            <button
              onClick={() => setShowVideoModal(true)}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
            >
              회사소개 동영상 보기
            </button>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-32 bg-gradient-to-br from-slate-50 to-blue-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-24">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">
              왜 올딩스 로지스인가?
            </h2>
            <p className="text-xl md:text-2xl text-gray-600 max-w-4xl mx-auto leading-relaxed font-medium">
              차별화된 서비스와 전문성으로 고객의 성공을 보장합니다
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
            <div className="text-center group">
              <div className="w-24 h-24 bg-gradient-to-br from-blue-500 to-blue-600 rounded-3xl flex items-center justify-center mx-auto mb-10 group-hover:scale-110 transition-transform duration-300 shadow-xl">
                <i className="ri-map-pin-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 leading-tight">내륙 중심의<br />최적 입지</h3>
              <p className="text-base text-gray-600 leading-relaxed">전국 배송 최적화를 위한 전략적 위치</p>
            </div>

            <div className="text-center group">
              <div className="w-24 h-24 bg-gradient-to-br from-green-500 to-green-600 rounded-3xl flex items-center justify-center mx-auto mb-10 group-hover:scale-110 transition-transform duration-300 shadow-xl">
                <i className="ri-team-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 leading-tight">고도로 숙련된<br />인력</h3>
              <p className="text-base text-gray-600 leading-relaxed">물류 전문가들의 체계적 관리</p>
            </div>

            <div className="text-center group">
              <div className="w-24 h-24 bg-gradient-to-br from-purple-500 to-purple-600 rounded-3xl flex items-center justify-center mx-auto mb-10 group-hover:scale-110 transition-transform duration-300 shadow-xl">
                <i className="ri-shirt-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 leading-tight">모든 품목<br />기반</h3>
              <p className="text-base text-gray-600 leading-relaxed">의류/패션/반려용품/잡화 등 전 품목 지원</p>
            </div>

            <div className="text-center group">
              <div className="w-24 h-24 bg-gradient-to-br from-orange-500 to-orange-600 rounded-3xl flex items-center justify-center mx-auto mb-10 group-hover:scale-110 transition-transform duration-300 shadow-xl">
                <i className="ri-global-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-6 leading-tight">글로벌<br />시장으로</h3>
              <p className="text-base text-gray-600 leading-relaxed">꼼꼼한 손길로 국내를 넘어 글로벌까지</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
